<template>
  <v-container fluid class="pa-6">
    <!-- Breadcrumbs -->
    <div class="lsp-breadcrumbs-container">
      <Breadcrumbs />
    </div>

    <!-- Hero Header Card -->
    <v-card class="lsp-hero-card mb-6" elevation="6">
      <div class="lsp-hero-header">
        <div class="d-flex align-center">
          <v-avatar size="48" class="lsp-hero-logo mr-4">
            <v-icon dark size="26">mdi-clipboard-check-multiple</v-icon>
          </v-avatar>
          <div>
            <h1 class="lsp-hero-title">List Specified Processes</h1>
            <p class="lsp-hero-subtitle mb-0">
              Select the organizational processes in scope for your certification
            </p>
          </div>
        </div>
      </div>

      <!-- Step Progress -->
      <div class="lsp-steps-bar">
        <div class="lsp-step lsp-step-done">
          <div class="lsp-step-circle lsp-step-circle-done">
            <v-icon size="18" color="white">mdi-check</v-icon>
          </div>
          <span class="lsp-step-label">Define SoC</span>
        </div>
        <div class="lsp-step-line lsp-step-line-done"></div>
        <div class="lsp-step lsp-step-active">
          <div class="lsp-step-circle lsp-step-circle-active">2</div>
          <span class="lsp-step-label">Configure</span>
        </div>
        <div class="lsp-step-line"></div>
        <div class="lsp-step">
          <div class="lsp-step-circle">3</div>
          <span class="lsp-step-label">Review</span>
        </div>
      </div>
    </v-card>

    <!-- Form Card -->
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card class="lsp-form-card" elevation="4">
          <v-form ref="serverForm" v-model="valid" lazy-validation>
            <v-card-text class="pa-6">
              <div class="lsp-field-label mb-4">
                <v-icon small color="#7b1fa2" class="mr-1">mdi-format-list-checks</v-icon>
                Select Processes in Scope
              </div>

              <div class="lsp-process-item mb-3">
                <div class="lsp-process-card">
                  <v-checkbox
                    v-model="secureDevelopment"
                    color="primary"
                    hide-details
                    class="mt-0 pt-0"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center" style="gap: 10px;">
                        <div class="lsp-process-icon lsp-process-icon--blue">
                          <v-icon size="18" color="white">mdi-shield-check-outline</v-icon>
                        </div>
                        <div>
                          <div class="lsp-process-title">Secure Development Lifecycle</div>
                          <div class="lsp-process-desc">
                            Security practices integrated into development
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>

              <div class="lsp-process-item mb-3">
                <div class="lsp-process-card">
                  <v-checkbox
                    v-model="configManagement"
                    color="primary"
                    hide-details
                    class="mt-0 pt-0"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center" style="gap: 10px;">
                        <div class="lsp-process-icon lsp-process-icon--purple">
                          <v-icon size="18" color="white">mdi-cog-outline</v-icon>
                        </div>
                        <div>
                          <div class="lsp-process-title">Configuration Management</div>
                          <div class="lsp-process-desc">
                            Tracking and controlling system configurations
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>

              <div class="lsp-process-item">
                <div class="lsp-process-card">
                  <v-checkbox
                    v-model="incidentResponse"
                    color="primary"
                    hide-details
                    class="mt-0 pt-0"
                  >
                    <template v-slot:label>
                      <div class="d-flex align-center" style="gap: 10px;">
                        <div class="lsp-process-icon lsp-process-icon--red">
                          <v-icon size="18" color="white">mdi-alert-outline</v-icon>
                        </div>
                        <div>
                          <div class="lsp-process-title">Incident Response</div>
                          <div class="lsp-process-desc">
                            Procedures for handling security incidents
                          </div>
                        </div>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </div>
            </v-card-text>

            <!-- Action Buttons -->
            <v-divider></v-divider>
            <v-card-actions class="pa-5 d-flex justify-center">
              <v-btn class="lsp-btn-clear mr-3" @click="clearForm">
                <v-icon left small>mdi-eraser</v-icon>
                Clear
              </v-btn>
              <v-btn class="lsp-btn-back mr-3" @click="$router.go(-1)">
                <v-icon left small>mdi-arrow-left</v-icon>
                Back
              </v-btn>
              <v-btn class="lsp-btn-next" :loading="loading" @click="handleNext">
                Next
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import util from '@/mixins/util';
import Breadcrumbs from '@/components/charts/Breadcrumbs.vue';

export default {
  name: 'ListSpecifiedProcesses',
  components: {
    Breadcrumbs,
  },
  mixins: [util],
  data() {
    return {
      loading: false,
      valid: false,
      secureDevelopment: false,
      configManagement: false,
      incidentResponse: false,
      certificationName: this.$route.query.name || '',
      certificationDescription: this.$route.query.description || '',
      subjectOfCertification: this.$route.params.subject || '',
      family: this.$route.query.family || '',
      origin: this.$route.query.origin || 'manual',
      threatSpiderComponent: null,
      threatSpiderStandard: null,
    };
  },
  mounted() {
    console.log('Certification Name:', this.certificationName);
    console.log('Certification Description:', this.certificationDescription);
    console.log('Subject of Certification:', this.subjectOfCertification);
    console.log('Family:', this.$route.query.family);
  },
  methods: {
    handleNext() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$router.push({
          name: 'Requirements',
          params: {
            subject: this.subjectOfCertification,
          },
          query: {
            name: this.certificationName,
            description: this.certificationDescription,
            secureDevelopment: this.secureDevelopment,
            configManagement: this.configManagement,
            incidentResponse: this.incidentResponse,
            family: this.family,
            origin: this.origin,
            threatSpiderStandard: this.threatSpiderStandard,
          },
        });
      }, 1000);
    },
    clearForm() {
      this.secureDevelopment = '';
      this.configManagement = '';
      this.incidentResponse = '';
      this.valid = false;
    },
  },
  created() {
    this.subject = this.$route.params.subject;
    this.family = this.$route.query.family;

    // Get component and standard from query params
    const threatSpiderComponent = this.$route.query.threatSpiderComponent;
    const threatSpiderStandard = this.$route.query.threatSpiderStandard;

    if (threatSpiderComponent && threatSpiderStandard) {
      this.threatSpiderComponent = threatSpiderComponent;
      this.threatSpiderStandard = threatSpiderStandard;

      // Set process flags based on component info
      if (this.threatSpiderComponent.Processes) {
        this.secureDevelopment = this.threatSpiderComponent.Processes.includes('SecureDevelopment');
        this.configManagement = this.threatSpiderComponent.Processes.includes('ConfigManagement');
        this.incidentResponse = this.threatSpiderComponent.Processes.includes('IncidentResponse');
      }
    }
  },
};
</script>

<style scoped>
/* ============================================
   LIST SPECIFIED PROCESSES - Modern Design
   ============================================ */

.lsp-breadcrumbs-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 28px;
}

.lsp-breadcrumbs-container .v-breadcrumbs {
  background-color: #ffffff;
  padding: 10px 20px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Hero Card */
.lsp-hero-card {
  border-radius: 16px !important;
  overflow: hidden;
  border: none !important;
  background: #ffffff;
}

.lsp-hero-header {
  background: linear-gradient(135deg, #00405e 0%, #006494 50%, #0097a7 100%);
  padding: 24px 28px;
}

.lsp-hero-logo {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(4px);
}

.lsp-hero-title {
  color: white;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.5px;
}

.lsp-hero-subtitle {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.92rem;
  font-weight: 400;
}

/* Step Progress Bar */
.lsp-steps-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 28px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-top: 1px solid #e8eef3;
}

.lsp-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.lsp-step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.95rem;
  background: #e0e0e0;
  color: #9e9e9e;
  transition: all 0.3s ease;
}

.lsp-step-circle-active {
  background: linear-gradient(135deg, #00405e, #0097a7);
  color: white;
  box-shadow: 0 4px 14px rgba(0, 100, 148, 0.4);
}

.lsp-step-circle-done {
  background: linear-gradient(135deg, #388e3c, #66bb6a);
  color: white;
  box-shadow: 0 4px 14px rgba(56, 142, 60, 0.35);
}

.lsp-step-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #78909c;
}

.lsp-step-active .lsp-step-label {
  color: #00405e;
}

.lsp-step-done .lsp-step-label {
  color: #388e3c;
}

.lsp-step-line {
  flex: 1;
  max-width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #e0e0e0, #bdbdbd);
  border-radius: 2px;
  margin: 0 12px;
  margin-bottom: 22px;
}

.lsp-step-line-done {
  background: linear-gradient(90deg, #66bb6a, #a5d6a7);
}

/* Form Card */
.lsp-form-card {
  border-radius: 16px !important;
  overflow: hidden;
  border: none !important;
}

.lsp-field-label {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 700;
  color: #37474f;
  letter-spacing: 0.3px;
}

/* Process Cards */
.lsp-process-card {
  padding: 14px 18px;
  background: linear-gradient(135deg, #f5f7fa 0%, #fafbfc 100%);
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  transition: all 0.25s ease;
}

.lsp-process-card:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 50%, #e8f5e9 100%);
  border-color: #bbdefb;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.lsp-process-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.lsp-process-icon--blue {
  background: linear-gradient(135deg, #1976d2, #42a5f5);
}

.lsp-process-icon--purple {
  background: linear-gradient(135deg, #7b1fa2, #ab47bc);
}

.lsp-process-icon--red {
  background: linear-gradient(135deg, #c62828, #ef5350);
}

.lsp-process-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #37474f;
}

.lsp-process-desc {
  font-size: 0.78rem;
  color: #90a4ae;
  margin-top: 1px;
}

/* Action Buttons */
.lsp-btn-clear {
  background: linear-gradient(135deg, #f37d21 0%, #ff9800 100%) !important;
  color: white !important;
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  padding: 0 20px !important;
  box-shadow: 0 4px 12px rgba(243, 125, 33, 0.3) !important;
  transition: all 0.3s ease !important;
}
.lsp-btn-clear:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(243, 125, 33, 0.5) !important;
}

.lsp-btn-back {
  background: linear-gradient(135deg, #78909c 0%, #90a4ae 100%) !important;
  color: white !important;
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  padding: 0 20px !important;
  box-shadow: 0 4px 12px rgba(120, 144, 156, 0.3) !important;
  transition: all 0.3s ease !important;
}
.lsp-btn-back:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(120, 144, 156, 0.5) !important;
}

.lsp-btn-next {
  background: linear-gradient(135deg, #00405e 0%, #006494 50%, #0097a7 100%) !important;
  color: white !important;
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  padding: 0 24px !important;
  box-shadow: 0 4px 14px rgba(0, 100, 148, 0.4) !important;
  transition: all 0.3s ease !important;
}
.lsp-btn-next:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 22px rgba(0, 100, 148, 0.6) !important;
}

/* Responsive */
@media (max-width: 960px) {
  .lsp-hero-header {
    padding: 20px;
  }
  .lsp-hero-title {
    font-size: 1.3rem;
  }
  .lsp-steps-bar {
    padding: 16px;
  }
}
</style>
